import React, { useEffect, useState} from 'react';
import analytics from '@react-native-firebase/analytics';

import {Container, Content, Footer, Form, InputGroup} from './styles';
import {Header} from '../../../components/Interface/Headers/Header';
import { useNavigation, useRoute} from '@react-navigation/native';
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Input} from '../../../components/Interface/Forms/Inputs/Input';
import {Keyboard, Platform, TouchableWithoutFeedback} from 'react-native';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {PedidoDTO} from '../../../dtos/PedidoDTO';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StationDTO } from '../../../dtos/StationDTO';

interface Params {
  pedidos: PedidoDTO;
  localidade: {
    rank: string;
    tipo: string;
    region: string;
    estado: string;
    cidade: string;
  };
  posto: StationDTO;
}

export function AutEstampagem() {
  const navigation = useNavigation();
  const route = useRoute();

  const [aut, setAut] = useState('');



  const {pedidos, localidade, posto} = route.params as Params;

  useEffect(() => {
    analytics().logEvent('tela_aut_estampagem');
  }, []);

  function handleChangePlacaText(extracted: any) {
    setAut(extracted);
  }

  function handleAddPlacaToPedidos() {
    pedidos.autEstampagem = aut;
    const paymentScreen = 'Payment';
    navigation.navigate(paymentScreen, {pedidos, localidade, posto});
  }
  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
    <TouchableWithoutFeedback onPress={() => Platform.OS !== 'web' && Keyboard.dismiss()}>
      <Container>
        <Header icon="chevron-left" action={() => navigation.goBack()} />
        <Content>
          <Titles
            title="Autorização de estapagem"
            subtitle="Digite a autorização de estampagem para continuar:"
          />
          <Form>
            <InputGroup>
              <Input
                labelText="Autorização de estampagem"
                keyboardType="default"
                placeholder="Digite a autorização de estampagem"
                onChangeText={extracted => handleChangePlacaText(extracted)}
                value={aut}
              />
            </InputGroup>
          </Form>
        </Content>
<Footer>
            <Button
              title="Continuar"
              enabled={aut.length >= 7}
              onPress={handleAddPlacaToPedidos}
            />

    </Footer>
      </Container>
    </TouchableWithoutFeedback>
    </SafeAreaView>
  );
}
